"use client";
import { KeyboardArrowDown} from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const AccordionComponent = ({
  defaultExpanded = false,
  title = "Accordion",
  children,
  detailsProps,
  ...props
}) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        borderRadius: "8px",
        border: "none",
        "&::before": { display: "none" },
      }}
      {...props}
    >
      <AccordionSummary
        expandIcon={<KeyboardArrowDown />}
        sx={{
          borderRadius: "8px",
          border: "none",
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails sx={{ borderRadius: 8, ...detailsProps }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionComponent;
